import { useEffect } from 'react'
import styles from './use-document-scroll-disabled.module.css'

export function useDocumentScrollDisabled(scrollDisabled: boolean): void {
  useEffect(() => {
    document.documentElement.classList[scrollDisabled ? 'add' : 'remove'](styles.html)
  }, [scrollDisabled])
}
